import {cloneDeep} from "lodash";
import {getArray, getNumber, getString, resetObjectValues} from 'Core/helpers/data';
import {ExpertReportTypeSectionDataObject, ExpertReportTypesItemDataObject} from '../dataObjects';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ExpertReportTypesItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ExpertReportTypesItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'defaultText'),
		getString(result, 'templateFileId'),
		getString(result, 'templateFileName'),
		getArray(result, 'expertReportTypeSections').map(s => new ExpertReportTypeSectionDataObject(
			getString(s, 'id'),
			getString(s, 'sectionName'),
			getString(s, 'sectionDefaultText'),
			getNumber(s, 'ordinal'),
		)),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {ExpertReportTypesItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep({
		id: inputData.id,
		name: inputData.name,
		defaultText: inputData.content,
		templateFileId: inputData.templateFileId,
		expertReportTypeSections: getArray(inputData, 'sections').map(s => ({
			id: s.id,
			sectionName: s.name,
			sectionDefaultText: s.defaultText,
			ordinal: s.ordinal,
		})),
	});

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}